import React, { useState } from "react";

function InfoCard(props) {
    const { image, videoUrl, heading, title, id, references, ...rest } = props;
    const [descExpanded, setDescExpanded] = useState(false);
    const descText = rest.description || "";
    const descIsLong = descText.length > 260;
    const descToShow = descExpanded || !descIsLong ? descText : descText.slice(0, 260) + "...";
    return (
        <div
            className="InfoCard"
            style={{
                margin: "0 auto 32px auto",
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 4px 24px 0 rgba(67,233,123,0.08)",
                padding: 24,
                maxWidth: 600
            }}
        >
            {/* Date and NEW badge (Feed only) */}
            {(rest.date || rest.isNew) && (
                <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", paddingBottom: 6 }}>
                    {rest.date && (
                        <span style={{ color: "#888", fontSize: 15, marginRight: rest.isNew ? 10 : 0 }}>
                            {new Date(rest.date).toLocaleDateString(undefined, {
                                year: "numeric",
                                month: "short",
                                day: "numeric"
                            })}
                        </span>
                    )}
                    {rest.isNew && (
                        <span
                            style={{
                                background: "linear-gradient(90deg, #43e97b 0%, #38f9d7 100%)",
                                color: "#fff",
                                borderRadius: 12,
                                fontWeight: 700,
                                fontSize: 13,
                                padding: "4px 14px",
                                marginLeft: 4,
                                letterSpacing: 1.2,
                                boxShadow: "0 2px 8px #43e97b44"
                            }}
                        >
                            NEW
                        </span>
                    )}
                </div>
            )}
            {videoUrl ? (
                <div
                    onClick={() => {
                        console.log("somesh iframe");
                        props.turnOffAudio();
                    }}
                    style={{
                        position: "relative",
                        width: "100%",
                        height: "min-content",
                        paddingBottom: "56.25%",
                        marginBottom: 18,
                        borderRadius: 12,
                        overflow: "hidden"
                    }}
                >
                    <iframe
                        src={videoUrl}
                        title={rest?.name ?? rest?.topic ?? ""}
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            borderRadius: 12,
                            border: "none"
                        }}
                    ></iframe>
                </div>
            ) : image ? (
                rest?.imagelink ? (
                    <a href={rest.imagelink} target="_blank" rel="noopener noreferrer">
                        <img
                            src={image}
                            alt={rest?.name ?? rest?.topic ?? ""}
                            style={{
                                width: "100%",
                                maxHeight: 440,
                                objectFit: "contain",
                                borderRadius: 12,
                                marginBottom: 18
                            }}
                        />
                    </a>
                ) : (
                    <img
                        src={image}
                        alt={rest?.name ?? rest?.topic ?? ""}
                        style={{
                            width: "100%",
                            maxHeight: 220,
                            objectFit: "cover",
                            borderRadius: 12,
                            marginBottom: 18
                        }}
                    />
                )
            ) : null}
            {/* Heading (topic or name) */}
            {(rest?.name ?? rest?.topic) && (
                <h2
                    style={{
                        textAlign: "center",
                        fontWeight: 700,
                        fontSize: 24,
                        margin: "0 0 18px 0",
                        color: "#22643a"
                    }}
                >
                    {rest?.name ?? rest?.topic}
                </h2>
            )}
            <div style={{ textAlign: "left" }}>
                {/* Only show causes, symptoms, prevention for Cure cards */}
                {rest?.causes && rest?.section === "cure" && (
                    <div style={{ marginBottom: 10 }}>
                        <span style={{ fontWeight: 600, color: "#22643a", marginRight: 8 }}>Causes:</span>
                        <span>{rest.causes}</span>
                    </div>
                )}
                {rest?.symptoms && rest?.section === "cure" && (
                    <div style={{ marginBottom: 10 }}>
                        <span style={{ fontWeight: 600, color: "#22643a", marginRight: 8 }}>Symptoms:</span>
                        <span>{rest.symptoms}</span>
                    </div>
                )}
                {rest?.prevention && rest?.section === "cure" && (
                    <div style={{ marginBottom: 10 }}>
                        <span style={{ fontWeight: 600, color: "#22643a", marginRight: 8 }}>Prevention:</span>
                        <span>{rest.prevention}</span>
                    </div>
                )}
                {descText && (
                    <div style={{ marginBottom: 10 }}>
                        <span>
                            {descToShow}
                            {descIsLong && (
                                <span
                                    style={{ color: "#43e97b", cursor: "pointer", fontWeight: 600, marginLeft: 8 }}
                                    onClick={() => setDescExpanded(exp => !exp)}
                                >
                                    {descExpanded ? "Show less" : "Read more"}
                                </span>
                            )}
                        </span>
                    </div>
                )}
                {/* Cure/Know: show references if present */}
                {rest?.section !== "feed" &&
                    (Array.isArray(references) && references?.length > 0
                        ? references
                        : Array.isArray(rest?.references) && rest?.references?.length > 0
                        ? rest.references
                        : null) && (
                        <div style={{ marginBottom: 10 }}>
                            <span style={{ fontWeight: 600, color: "#22643a", marginRight: 8 }}>Useful References</span>
                            <ul style={{ margin: "6px 0 0 0", paddingLeft: 18 }}>
                                {(Array.isArray(references) && references?.length > 0
                                    ? references
                                    : rest?.references ?? []
                                ).map((ref, idx) => (
                                    <li key={idx}>
                                        <a
                                            href={ref?.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: "#43e97b" }}
                                        >
                                            {ref?.label ?? ref?.url}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                {/* Feed: show fullArticleLink at bottom if present */}
                {rest?.section === "feed" && rest?.fullArticleLink && (
                    <div style={{ marginTop: 18 }}>
                        <a
                            href={rest?.fullArticleLink?.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#43e97b", fontWeight: 600 }}
                        >
                            {rest?.fullArticleLink?.label ?? rest?.fullArticleLink?.url}
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
}

export default InfoCard;
